<form
  [formGroup]="userForm"
  (ngSubmit)="submitUserForm($event)"
  class="user-form"
  *ngIf="strapiFromData"
  id="update-form"
  (keydown.enter)="$event.preventDefault()"
>
  <h2>{{ strapiFromData.title }}</h2>
  <div
    class="form-errors"
    *ngIf="
      (submited() || userControl['university_name'].dirty) &&
      userControl['university_id'].errors
    "
  >
    <p class="form-error">
      {{
        !strapiFromData ||
          strapiFromData.university_name_error ||
          'Please select or enter your University or College'
      }}
    </p>
  </div>

  <input
    type="hidden"
    name="university_id"
    id="university_id"
    formControlName="university_id"
  />

  <div class="form-row">
    <div class="form-field">
      <div class="label-container">
        <label for="university_name">{{
          strapiFromData.university_name || 'University name'
        }}</label>
        <!--        <app-tooltip-->
        <!--          *ngIf="strapiFromData.university_name_tooltip"-->
        <!--          id="university_name_tooltip"-->
        <!--          (tooltipClicked)="openTooltip($event)"-->
        <!--        ></app-tooltip>-->
      </div>
      <div class="lookup-wrapper">
        <input
          class="modal-lookup postcode-field-width"
          formControlName="university_name"
          type="text"
          name="university_name"
          id="university_name"
          [class.error]="
            (submited() || userControl['university_name'].dirty) &&
            userControl['university_id'].errors
          "
          (focus)="displayUniLookupModal()"
          (click)="displayUniLookupModal()"
        />
        <a
          href="#"
          class="lookup-list-link"
          id="uni-lll"
          (click)="displayUniListModal($event)"
        >
          List
        </a>
      </div>
    </div>
  </div>

  <app-modal
    [show]="showUniLookupModal()"
    (showChange)="showUniLookupModal.set($event)"
    [showBuddy]="true"
    #uniLookupModal
  >
    <h3 class="modal-title">
      {{ strapiFromData.university_name || 'University name' }}
    </h3>
    <app-uni-lookup
      (closeSelf)="hideUniSelectionModals()"
      (uniSelected)="universitySelected($event)"
      (addUni)="changeShowAddUniModal($event)"
      (alternativeUni)="handleNotAtUni()"
      [noUnisFoundMessage]="
        strapiFromData.no_unis_found_message ||
        'No Universities found containing'
      "
      [searchTerm]="uniLookupSearchTerm()"
      #uniLookup
    ></app-uni-lookup>
  </app-modal>

  <app-modal
    [show]="showUniListModal()"
    (showChange)="showUniListModal.set($event)"
    [showBuddy]="true"
    #uniListModal
  >
    <h3 class="modal-title">
      {{
        strapiFromData.list_modal_title || 'Choose your University or College'
      }}
    </h3>
    <app-uni-list
      (uniSelected)="universitySelected($event)"
      (alternativeUni)="handleNotAtUni()"
      (addUni)="changeShowAddUniModal($event)"
      [noUnisFoundForLetterMessage]="
        strapiFromData.no_unis_found_with_that_letter_message ||
        'No Universities or Colleges could be found with that letter. Please add your University/College.'
      "
    ></app-uni-list>
  </app-modal>

  <app-modal
    [show]="showUniAddModal()"
    (showChange)="showUniAddModal.set($event)"
    [showBuddy]="true"
    #uniAddModal
  >
    <h3 class="modal-title">Add your University or College</h3>
    <app-uni-add
      (uniAdded)="universityEntered($event)"
      [prefill]="addUniPrefill()"
      #uniAdd
    ></app-uni-add>
  </app-modal>

  <input
    type="hidden"
    name="residence_id"
    id="residence_id"
    formControlName="residence_id"
  />

  <div
    class="form-errors"
    *ngIf="
      (submited() || userControl['residence_name'].dirty) &&
      userControl['residence_id'].errors
    "
  >
    <p
      class="form-error"
      *ngIf="userControl['residence_id'].errors['required']"
    >
      {{
        strapiFromData.staying_error ||
          'Please select or enter your accommodation whilst at University'
      }}
    </p>
  </div>

  <div class="form-row">
    <div class="form-field">
      <div class="label-container">
        <label for="residence_name">{{
          accommodationStayingText() ||
            'Where are you staying whilst at university?'
        }}</label>
        <!--        <app-tooltip-->
        <!--          *ngIf="strapiFromData.staying_tooltip && !isPathwayProvider"-->
        <!--          id="staying_tooltip"-->
        <!--          (tooltipClicked)="openTooltip($event)"-->
        <!--        ></app-tooltip>-->
      </div>
      <p>{{ strapiFromData.staying_info_copy }}</p>
      <div class="lookup-wrapper">
        <input
          class="modal-lookup"
          formControlName="residence_name"
          type="text"
          name="residence_name"
          id="residence_name"
          [class.error]="
            (submited() || userControl['residence_name'].dirty) &&
            userControl['residence_id'].errors
          "
          (focus)="displayResidenceLookupModal()"
          (click)="displayResidenceLookupModal()"
        />
        <a
          href="#"
          class="lookup-list-link"
          id="residence-lll"
          (click)="displayResidenceListModal($event)"
          >List</a
        >
      </div>
    </div>
  </div>
  <!-- Accommodation List search -->
  <app-modal
    [show]="showResidenceLookupModal()"
    (showChange)="showResidenceLookupModal.set($event)"
    [showBuddy]="true"
    #residenceLookupModal
  >
    <h3 class="modal-title">
      {{
        accommodationStayingText() ||
          'Where are you staying whilst at university?'
      }}
    </h3>
    <p>{{ strapiFromData.staying_info_copy }}</p>
    <app-residence-lookup
      (closeSelf)="hideResidenceSelectionModals()"
      (residenceSelected)="residenceSelected($event)"
      (alternateResidence)="handleAlternateResidence($event)"
      [noResidencesFoundMessage]="
        strapiFromData.no_accommodations_found_message ||
        'No accommodations found containing'
      "
      [searchTerm]="residenceLookupSearchTerm()"
      #residenceLookup
    ></app-residence-lookup>
  </app-modal>

  <!-- Accommodation Manual search  -->
  <app-modal
    [show]="showResidenceListModal()"
    (showChange)="showResidenceListModal.set($event)"
    [showBuddy]="true"
    #residenceListModal
  >
    <h3 class="modal-title">
      {{
        accommodationStayingText() ||
          'Where are you staying whilst at university?'
      }}
    </h3>
    <p>{{ strapiFromData.staying_info_copy }}</p>
    <app-residence-list
      (residenceSelected)="residenceSelected($event)"
      (alternateResidence)="handleAlternateResidence($event)"
      [noResidencesFoundForLetterMessage]="
        strapiFromData.no_accommodations_found_with_that_letter_message ||
        'No accommodations found for that letter group'
      "
    ></app-residence-list>
  </app-modal>
  <div class="form-errors update-error" *ngIf="updateError()">
    <p class="form-error">
      {{
        strapiFromData.user_error_message ||
          'There was a problem updating your details. Please contact us if you require assistance.'
      }}
    </p>
  </div>
  <div class="flex">
    <p (click)="cancel()">cancel</p>
    <button type="submit" form="update-form">Save changes</button>
  </div>
</form>
